import { render } from "./MyCourse.vue?vue&type=template&id=1f865462&scoped=true"
import script from "./MyCourse.vue?vue&type=script&lang=js"
export * from "./MyCourse.vue?vue&type=script&lang=js"

import "./MyCourse.vue?vue&type=style&index=0&id=1f865462&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f865462"]])

export default __exports__